import { AlertMessage } from '@/app/components'
import { Text } from '@/components'
import {
  OPEN_APPLICATION_SETTINGS_ACTION,
  postEventToMobileIfPresent,
} from '@/utils/messageUtils'

export default function PushNotificationsDisabledAlertMessage() {
  const openApplicationSettings = () => {
    postEventToMobileIfPresent(OPEN_APPLICATION_SETTINGS_ACTION)
  }

  return (
    <AlertMessage variant="warning" className="mb-8">
      <div className="mb-2">
        You've got notifications turned off in your settings. Turn them on so
        you don't miss important updates.
      </div>
      <Text
        variant="link"
        className="font-bold"
        onClick={openApplicationSettings}
      >
        Go to Settings
      </Text>
    </AlertMessage>
  )
}
